import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {assert} from 'Asserts';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {TooltipWrapper} from 'ui-library/bs/Tooltip';
import Button, {ButtonStyle} from 'ui-library/buttons/Button';
import * as Colors from 'ui-library/Colors';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {MenuWidth} from 'ui-library/menus/MenuConstants';
import MenuPopover from 'ui-library/menus/MenuPopover';

import {BaseFilterFormProps} from './FilterFormConstants';

interface PrimaryFilterFormSkeletonProps extends BaseFilterFormProps {
  closeOnInsideClick: boolean;
  content?: JSX.Element;
  // HACK: This is needed to pass up the dropdown ref for the menuOverride
  dropdownRef?: (node: Dropdown) => void;
  menuOverride?: JSX.Element;
  tooltipTitle?: string | null;
  dataTestAttrs?: DataTestAttrs;
  alwaysDropDown?: boolean;
}

export default class PrimaryFilterFormSkeleton extends React.Component<PrimaryFilterFormSkeletonProps> {
  static defaultProps = {
    closeOnInsideClick: false,
  };

  render(): JSX.Element {
    const isInvalid = this.props.invalidMessage != null;
    let buttonStyle = ButtonStyle.TERTIARY_GRAY;
    if (isInvalid) {
      buttonStyle = ButtonStyle.WARNING_LIGHT;
    } else if (this.props.isActive) {
      buttonStyle = ButtonStyle.TERTIARY_BLUE_POWDER;
    }
    assert(
      Boolean(this.props.menuOverride) !== Boolean(this.props.content),
      'Expected menuOverride or content.'
    );
    return (
      <TooltipWrapper tooltipTitle={this.props.invalidMessage || this.props.tooltipTitle}>
        <Dropdown
          closeOnInsideClick={this.props.closeOnInsideClick}
          closeOnOutsideClick={true}
          menu={
            this.props.menuOverride ? (
              this.props.menuOverride
            ) : (
              <MenuPopover className={css(styles.menu)} width={MenuWidth.FULL}>
                {this.props.content}
              </MenuPopover>
            )
          }
          ref={this.props.dropdownRef}
          alwaysDropDown={this.props.alwaysDropDown}
        >
          <Button
            buttonStyle={buttonStyle}
            fullWidth={true}
            icon={
              (isInvalid && <BenchlingIcon className={css(styles.buttonIcon)} icon="warning" />) as
                | JSX.Element
                | undefined
            }
            disabled={this.props.isDisabled}
            isDropdown={true}
            size={this.props.buttonSize}
            text={this.props.dropdownToggleText}
            textClassName={css(styles.buttonText)}
            dataTestAttrs={this.props.dataTestAttrs}
          />
        </Dropdown>
      </TooltipWrapper>
    );
  }
}

const styles = StyleSheet.create({
  menu: {
    minWidth: 220,
  },
  buttonIcon: {
    color: Colors.ORANGE,
  },
  buttonText: {
    lineHeight: 1.2,
    maxWidth: 220,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});
